import {
  Box,
  Button,
  Container,
  CssBaseline,
  ThemeProvider,
  Typography,
} from '@mui/material';
import React from 'react';
import logo from '../../assets/Img/seed.png';
// import LoginLoadingAnimation from '../../components/LoadingLogin';
import { handleGoogleLogin } from './LoginMiddleware';
import { primaryColor, secondaryColor, theme, userRoles } from './SimpleComp';
import { stylesBox } from './styles';

const GoogleIcon: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#EA4335"
      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
    />
    <path
      fill="#4285F4"
      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
    />
    <path
      fill="#FBBC05"
      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
    />
    <path
      fill="#34A853"
      d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
    />
  </svg>
);

interface GoogleLoginButtonProps {
  roleId: number;
  onLogin: (roleId: number) => void;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({
  roleId,
  onLogin,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 2,
    }}
  >
    <Button
      onClick={() => onLogin(roleId)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        pl: '6px',
        pr: '28px',
        height: '52px',
        minWidth: '260px',
        backgroundColor: '#fff',
        border: '1px solid',
        borderColor: 'rgba(0,0,0,0.12)',
        borderRadius: '26px',
        textTransform: 'none',
        color: 'rgba(0,0,0,0.75)',
        fontWeight: 500,
        fontSize: '15px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: '#f8f8f8',
          borderColor: 'rgba(0,0,0,0.22)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
          transform: 'translateY(-1px)',
        },
        '&:active': {
          transform: 'scale(0.98)',
          boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
        },
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          backgroundColor: '#f1f3f4',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <GoogleIcon />
      </Box>
      Entrar com Google
    </Button>

    <Typography
      variant="caption"
      sx={{
        color: 'text.disabled',
        textAlign: 'center',
        maxWidth: 280,
        lineHeight: 1.6,
        fontSize: '0.85rem',
      }}
    >
      Apenas contas{' '}
      <Box component="span" sx={{ fontWeight: 500, color: 'text.secondary' }}>
        @escola.pr.gov.br
      </Box>{' '}
      são permitidas
    </Typography>
  </Box>
);

interface HomeContentProps {
  onLogin: (roleId: number) => void;
}

const HomeContent: React.FC<HomeContentProps> = ({ onLogin }) => (
  <Box sx={stylesBox.boxOne}>
    <Box
      sx={{
        position: 'absolute !important',
        top: 0,
        left: 0,
        width: '100% !important',
        height: '8px !important',
        opacity: '0.7 !important',
        background: `linear-gradient(90deg, ${primaryColor}, ${secondaryColor}) !important`,
      }}
    />

    <Container maxWidth="sm">
      <Box sx={stylesBox.boxThree}>
        <Box sx={stylesBox.boxFour}>
          {/* Logo */}
          <Box sx={stylesBox.boxFive}>
            <Box
              component="img"
              src={logo}
              alt="Redação Paraná"
              sx={stylesBox.boxSix}
            />
          </Box>

          {/* Botões de login */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3,
              mb: { xs: '34px', sm: '44px', md: '54px', lg: '64px' },
            }}
          >
            {userRoles
              .filter((role) => role.isPrimary)
              .map((role) => (
                <GoogleLoginButton
                  key={role.id}
                  roleId={role.id}
                  onLogin={onLogin}
                />
              ))}
          </Box>
        </Box>
      </Box>
    </Container>
  </Box>
);

const HomePage: React.FC = () => {
  const login = (roleId: number) => handleGoogleLogin(roleId);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HomeContent onLogin={login} />
    </ThemeProvider>
  );
};

export default HomePage;
